var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorisationRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.651,
    height: 24,
    viewBox: "0 0 24.651 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8820",
    "data-name": "Group 8820",
    transform: "translate(-694 -297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computer_24dp",
    transform: "translate(694 297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    d: "M20,18a2,2,0,0,0,1.99-2L22,6a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,6V16a2.006,2.006,0,0,0,2,2H0v2H24V18ZM4,6H20V16H4Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 4.639,
    cy: 4.639,
    rx: 4.639,
    ry: 4.639,
    transform: "translate(708.162 309.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8819",
    "data-name": "Group 8819",
    transform: "translate(707 308.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M7.7,2a5.7,5.7,0,1,0,5.7,5.7A5.7,5.7,0,0,0,7.7,2Zm0,10.261A4.561,4.561,0,1,1,12.261,7.7,4.567,4.567,0,0,1,7.7,12.261Z",
    transform: "translate(-2 -2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M10.965,7.58l-3.09,3.09L6.661,9.46,6,10.121,7.875,12l3.751-3.751Z",
    transform: "translate(703.888 304.426)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorisationRequest);
export default __webpack_public_path__ + "static/media/Authorisation_request.510df8e68d67aa250926c310236a7d3a.svg";
export { ForwardRef as ReactComponent };